import React from 'react';
import registeredComponent from '../../utils/registeredComponent';
import CustomField from './CustomField';
import { fusionForms } from '../../ducks/index';
import duckify, { singleDuck } from '../../utils/duckify';
import { getHtmlId, getHtmlName } from './utils/CustomFieldHelpers';
import { getMetaContent } from '../../utils';
import { SubmitLinks } from './SubmitLinks';
import { Navigation } from './Navigation';
import { Body } from './Body';
import { FsHeading } from '@finalsite/wc-react';
import answerTracker from './utils/answerTracker';
import './fusion_forms.scss'
import { FsSelect, FsOption, FsInput } from '@finalsite/wc-react';

/*
Renders full Fusion Form, including navigation, body, and submit links.
@param form - the form object, which contains the template and pages
@param page - the current page number (1-indexed)
 */
const FusionForm = ({form, page, allDucksReady, duckMeta}) => {
  const {setFieldValue, getFieldValue, useDependency} = answerTracker({form, meta: duckMeta.form});

  if(!allDucksReady) { return <div>loading...</div> }

  return <div className={'fusion-form'}>
    <FsHeading className={'form-title'}>
      {form.template.name}
    </FsHeading>

    <form id={form.form_class}
          name={form.form_class}
          action={form.submit_action_url}
          method={'POST'}
    >
      <div className={'form-page'}>
        <input type={'hidden'} name={'page'} value={page}/>
        <input type={'hidden'} name={'id'} value={form.id}/>
        <input type={'hidden'} name={'utf8'} value={'✓'}/>
        <input type={'hidden'} name={'authenticity_token'} value={getMetaContent('csrf-token')}/>

        <Navigation form={form} page={page}/>

        <Body form={form} page={page} {...{setFieldValue, getFieldValue, useDependency}}/>
      </div>
    </form>
  </div>;
};

const mapDucksToProps = (props) => ({
  form: singleDuck(fusionForms, props.form_id)
});

const mapDispatchToProps = (dispatch) => ({
});

const DuckifiedFusionForm = duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(FusionForm);

export default registeredComponent("FusionForm")(DuckifiedFusionForm);
